import React from "react";

import { Disclosure } from "@headlessui/react";
import { FiChevronDown } from "react-icons/fi";
import {Link} from "react-router-dom"

// import { Link } from "@material-ui/core";

const FilterToggle = ({
  children,
  title,
  className,
  span1,
  iconClass,
  top,
  padding,
  icon,

}) => {
  return (
    <Disclosure as="div" key="" className={` w-100 position-relative ${top}`}>
      {({ open }) => (
        <>
          <Disclosure.Button
            className={`${
              className ? className : ""
            } d-flex  outline-none align-items-center  py-4 justify-content-between w-100 fltr ${padding}`}
          >
            {icon ? (
              <Link to="/reportoverview/coaches">
           <span className="menu-icon d-flex hover">
           <span className="material-icons material-icons-outlined ml-1 hover text2">
             report
           </span>
           <p className="mt-1 ml-3 text2 hover">Reporting</p>
         </span>
        </Link>
            ) : (
              <span
                style={{ fontSize: "1rem", color: "#948E8E" }}
                className={span1} 
              >
                {title}
              </span>
            )}
              <FiChevronDown
                style={{ height: "20px", width: "20px", color: "#948E8E"  }}
                className={` ${open ? "rotate-180" : ""} ${iconClass}`}
              />
          </Disclosure.Button>
          <Disclosure.Panel as="dd" className={`mt-0`}>
            {children}
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
};

export default FilterToggle;
